import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useClinicalEventsModal } from '../Drawer/Provider';
import styles from '../index.module.scss';

const AddClinicalEvent = ({ isEmptyEvents }: { isEmptyEvents?: boolean }) => {
  const { setContextData } = useClinicalEventsModal();

  const onAddEvent = () => {
    setContextData({ isNewItem: true });
  };

  return (
    <div
      className={classNames(styles.addEventContainer, {
        [styles.customAddEvent]: !isEmptyEvents,
      })}
    >
      <IconButton className={styles.addEvent} onClick={onAddEvent}>
        <AddIcon color={'primary'} />
        <span> New event</span>
      </IconButton>
    </div>
  );
};

export default observer(AddClinicalEvent);
